import React from "react";
import styles from "./Footer.module.scss";
import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";

const Footer = () => {
    const {t} = useTranslation();

    const links = [
        {
            title: t("footer.return"),
            href: "/return",
        },
        {
            title: t("footer.how_to_start", "Как начать"),
            href: "/how-to-order",
        },
        {
            title: t("footer.offer", "Оферта"),
            href: "/offer",
        },
    ];

    return (
        <footer className={styles.footer}>
            <div className="container">
                <nav aria-label={"Footer navigation"}>
                    <ul className={styles.linksList}>
                        {links.map((link) => (
                            <li key={link.href}>
                                <NavLink
                                    to={link.href}
                                    className={({isActive}) =>
                                        isActive ? `${styles.link} ${styles.active}` : styles.link
                                    }
                                >
                                    {link.title}
                                </NavLink>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;